import React from 'react'
import { hydrate } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import ApolloClient from 'apollo-client'
import { ApolloProvider } from 'react-apollo'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import { loadableReady } from '@loadable/component'
// Redux
import { Provider } from 'react-redux'
import { createStore, compose } from 'redux'

import Main from './components/Main'
import reducers from './store/reducers'
import initialState from './store/initialState'
import { venture, basename, apiUrl } from './config'

const ventureLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      venture
    }
  }
})

const httpLink = createHttpLink({
  uri: apiUrl
})

const store = createStore(
  reducers,
  initialState, // initial state
  compose(
    // If you are using the devToolsExtension, you can add it here also
    typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )
)

// Polyfill Object Assign IE11
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign (target, varArgs) {
      // .length of function is 2
      'use strict'
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object')
      }

      const to = Object(target)

      for (let index = 1; index < arguments.length; index++) {
        const nextSource = arguments[index]

        if (nextSource != null) {
          // Skip over if undefined or null
          for (const nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey]
            }
          }
        }
      }
      return to
    },
    writable: true,
    configurable: true
  })
}
// support APQ in production
// if (process.env.NODE_ENV === 'production') {
//   links.unshift(createPersistedQueryLink());
// }
const client = new ApolloClient({
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
  ssrForceFetchDelay: 100,
  link: ventureLink.concat(httpLink)
  // connectToDevTools: true,
  // here we're initializing the cache with the data from the server's cache
})

loadableReady(() => {
  hydrate(
    <Provider store={store}>
      <ApolloProvider client={client}>
        <BrowserRouter basename={basename}>
          <Main variant={window.__VARIANT__} venture={venture} />
        </BrowserRouter>
      </ApolloProvider>
    </Provider>,
    document.getElementById('app')
  )
})
